import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

const GOOGLE_SCRIPT_ID = 'google-identity';

export function GoogleAuthButton({ onSuccess }: { onSuccess?: () => void }) {
    const { loginWithGoogle } = useAuth();
    const buttonRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
        if (!clientId) {
            return;
        }

        const initialize = () => {
            if (!window.google || !buttonRef.current) return;
            window.google.accounts.id.initialize({
                client_id: clientId,
                callback: async (response: { credential: string }) => {
                    await loginWithGoogle(response.credential);
                    onSuccess?.();
                },
                auto_select: true,
                cancel_on_tap_outside: false,
            });

            window.google.accounts.id.renderButton(buttonRef.current, {
                theme: 'outline',
                size: 'large',
                text: 'continue_with',
                shape: 'pill',
                width: 360,
            });

            window.google.accounts.id.prompt();
        };

        if (!document.getElementById(GOOGLE_SCRIPT_ID)) {
            const script = document.createElement('script');
            script.id = GOOGLE_SCRIPT_ID;
            script.src = 'https://accounts.google.com/gsi/client';
            script.async = true;
            script.defer = true;
            script.onload = initialize;
            document.body.appendChild(script);
        } else {
            initialize();
        }
    }, [loginWithGoogle, onSuccess]);

    return <div ref={buttonRef} className="w-full flex justify-center" />;
}
